export const getLocalLang = () => {
  const lang = localStorage.getItem('language');

  return lang;
};

export const setLocalLang = (lang) => {
  // localStorage의 key 전부를 가져온다.
  const keys = Object.keys(localStorage);
  // localStorage의 key 중 "map_info" 혹은 "map_event"가 포함된 배열.
  const mapKeys = keys.filter((key) => key.includes('map_info') || key.includes('map_event'));
  // mapKeys의 배열을 순회하며 localStorage의 key를 삭제한다.
  mapKeys.forEach((key) => localStorage.removeItem(key));

  localStorage.setItem('language', lang);
};

export const getNaviLang = () => {
  const naviLang = navigator.language || navigator.userLanguage || 'en';

  // - 기준으로 나누기
  const [lang] = naviLang.split('-');

  // 한국어가 아니면 영어로 설정
  if (!['ko'].includes(lang)) return 'en';

  return lang;
};

export const getLang = () => {
  const lang = getLocalLang();

  if (lang) return lang;

  const naviLang = getNaviLang();

  setLocalLang(naviLang);

  return naviLang;
};
